<form #form="ngForm" name="form" (ngSubmit)="onSubmit()">
  <p-dialog header="Edit Template Assignment" widgetVar="dlg" modal="true" [(visible)]="visible" (onHide)="onClose()" class="edit-dialog">
    <div class="grid p-fluid">
      <div class="col-12">
        <div class="grid p-fluid">
          <div class="col-6">
            <div class="grid tw-mb-4">
              <label class="col-4" for="versionNumber">Version: </label>
              <div class="col-8">
                <p-dropdown name="versionNumber" [options]="allVersions" placeholder="Select A Version" appendTo="body" styleClass="w-full"
                  (onChange)="onVersionChange()" [(ngModel)]="versionNumber" [filter]="true" filterBy="label" [ngModelOptions]="{standalone: true}">
                </p-dropdown>
              </div>

              <label class="col-4" for="sortOrder">Sort Order: </label>
              <div class="col-8">
                <p-inputNumber name="sortOrder" [(ngModel)]="model.sortOrder" class="w-full" [showButtons]="true"></p-inputNumber>
              </div>

              <label class="col-4" for="taskDeadlineDate">Task Deadline Date: </label>
              <div class="col-8">
                <p-calendar name="taskDeadlineDate" [(ngModel)]="model.taskDeadlineDate" class="w-full"></p-calendar>
              </div>
            </div>
          </div>
          <div class="col-6" *ngIf="showIsApproved">
            <div class="col-12 text-right">
              <p-checkbox name="isApproved" [(ngModel)]="model.isApproved" binary="true" label="Approved"></p-checkbox>
            </div>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12">
            <div class="grid">
              <label class="col-2" for="taskDeadlineNotes">Task Deadline Notes: </label>
              <div class="col-10">
                <textarea pInputTextArea name="taskDeadlineNotes" [(ngModel)]="model.taskDeadlineNotes" rows="5" class="w-full"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12">
            <div class="grid">
              <label class="col-2">Modified By: </label>
              <div class="col-10">
                <b>{{model.modifiedBy}}</b>
              </div>
            </div>
            <div class="grid">
              <label class="col-2">Last Modified: </label>
              <div class="col-10">
                <b>{{model.modifiedOn}}</b>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <p-footer>
      <button type="button" pButton icon="pi pi-fw pi-times" (click)="close()" label="Cancel"></button>
      <button type="submit" pButton icon="pi pi-fw pi-check" label="Save" class="ui-button-success" [disabled]="isFormInvalid()"></button>
    </p-footer>
  </p-dialog>
</form>